import { render, staticRenderFns } from "./RegisterObligations.vue?vue&type=template&id=2dc029e8&scoped=true"
import script from "./RegisterObligations.vue?vue&type=script&lang=js"
export * from "./RegisterObligations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc029e8",
  null
  
)

export default component.exports